
export default {
  name: "PaymentInfoForm",

  computed: {
    payment: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },

    radioKey() {
      const p = this.payment || {};
      return `rg-${p.credito_recorrente}-${p.isento_adesao}-${p.forma_pagamento_adesao}`;
    },

    valorAdesaoExibir() {
      if (this.payment?.isento_adesao) return 0;
      return this.valor_adesao || 0;
    },
  },

  filters: {
    dinheiro(value) {
      let dinheiro = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return dinheiro.format(value || 0);
    },
  },

  props: {
    value: Object,
    incrementAmount: Boolean,
    amount: Number,
    memberslength: Number,
    valor_adesao: Number,
  },

  mounted() {
    // Defaults e coerência inicial
    const p = { ...(this.payment || {}) };
    let mudou = false;

    if (typeof p.credito_recorrente === "undefined") {
      p.credito_recorrente = false;
      mudou = true;
    }
    if (typeof p.forma_pagamento === "undefined") {
      p.forma_pagamento = "";
      mudou = true; // método mensal eliminado
    }
    if (typeof p.isento_adesao === "undefined") {
      p.isento_adesao = false;
      mudou = true;
    }
    if (typeof p.forma_pagamento_adesao === "undefined") {
      p.forma_pagamento_adesao = "";
      mudou = true;
    }
    // Coerência quando já vier marcado como recorrente
    if (p.credito_recorrente) {
      if (p.forma_pagamento !== "recorrente") {
        p.forma_pagamento = "recorrente";
        mudou = true;
      }
      if (p.forma_pagamento_adesao !== "recorrente") {
        p.forma_pagamento_adesao = "recorrente";
        mudou = true;
      }
      if (p.isento_adesao) {
        p.isento_adesao = false;
        mudou = true;
      }
    } else {
      // Se isento, método da adesão vazio
      if (p.isento_adesao && p.forma_pagamento_adesao !== "") {
        p.forma_pagamento_adesao = "";
        mudou = true;
      }
      // Se não recorrente e método adesão estava 'recorrente', limpa para escolha manual
      if (!p.isento_adesao && p.forma_pagamento_adesao === "recorrente") {
        p.forma_pagamento_adesao = "";
        mudou = true;
      }
    }
    if (mudou) this.$emit("change", p);

    console.log(
      "============ p.forma_pagamento_adesao===",
      p.forma_pagamento_adesao,
      p.forma_pagamento
    );
  },

  methods: {
    onToggleRecorrente(val) {
      // 1) Emite o novo estado
      const base = {
        ...this.payment,
        credito_recorrente: !!val,
        forma_pagamento: val ? "recorrente" : "",
        isento_adesao: val ? false : this.payment.isento_adesao,
        forma_pagamento_adesao: val
          ? "recorrente"
          : this.payment.isento_adesao
          ? ""
          : this.payment.forma_pagamento_adesao || "",
      };
      this.$emit("change", base);

      // 2) Garante seleção visual após o DOM do pai reagir
      if (val) {
        this.$nextTick(() => {
          const reforco = {
            ...this.payment,
            forma_pagamento_adesao: "recorrente",
          };
          this.$emit("change", reforco);
        });
      }
    },

    onToggleIsencao(val) {
      const proximo = {
        ...this.payment,
        isento_adesao: !!val,
        // Se isento, método de adesão vazio; grupo fica desabilitado por isento=true
        forma_pagamento_adesao: val ? "" : this.payment.forma_pagamento_adesao,
      };
      this.$emit("change", proximo);

      // Se tirar isenção e não for recorrente, não marca nada: obriga o usuário a escolher
      if (
        !val &&
        !this.payment?.credito_recorrente &&
        !this.payment?.forma_pagamento_adesao
      ) {
        this.$nextTick(() => {
          this.$emit("change", { ...this.payment, forma_pagamento_adesao: "" });
        });
      }
    },
  },
};
